export function convertToGutterSheetMeasurements(measurements) {
  const gutterSheetNames = [
    "Gutter_Sheet_Left",
    "Gutter_Sheet_Right",
    "Gutter_Sheet_Front",
    "Gutter_Sheet_Rear",
    "Gutter_Sheet_Garage",
    "Gutter_Sheet_Other",
  ];

  const result = {
    Gutter_Sheet_Measurements: {},
  };

  // Initialize totals
  const totals = {
    firstStory: 0,
    secondStory: 0,
    thirdStory: 0,
  };

  // Process each measurement object (excluding empty ones)
  measurements.forEach((measurement, index) => {
    // Skip empty measurements or if we've exceeded our gutter sheet names
    if (
      index >= gutterSheetNames.length ||
      (!measurement.firstStory &&
        !measurement.secondStory &&
        !measurement.thirdStory)
    ) {
      return;
    }

    const gutterSheetName = gutterSheetNames[index];

    // Convert string values to numbers, treat empty strings as 0
    const firstStory = parseInt(measurement.firstStory) || 0;
    const secondStory = parseInt(measurement.secondStory) || 0;
    const thirdStory = parseInt(measurement.thirdStory) || 0;

    // Add to result
    result.Gutter_Sheet_Measurements[gutterSheetName] = {
      firstStory: firstStory,
      secondStory: secondStory,
      thirdStory: thirdStory,
    };

    // Add to totals
    totals.firstStory += firstStory;
    totals.secondStory += secondStory;
    totals.thirdStory += thirdStory;
  });

  // Add totals
  result.Gutter_Sheet_Measurements.Gutter_Sheet_Total = totals;

  return result;
}


export function convertToStringArray(value) {
    if (Array.isArray(value)) {
        return value.map(item => String(item).trim());
    }
    
    if (typeof value === 'string') {
        return value.split(',').map(item => item.trim());
    }
    
    return [];
}


export const transformImages = (inputImages) => {
  // Mapping from object keys to array labels
  const keyToLabelMap = {
    "rightSide": "Right Side",
    "leftSide": "Left Side",
    "backLeft": "Back-Left",
    "frontOfHome": "Front of Home",
    "frontLeft": "Front-Left",
    "frontRight": "Front-Right",
    "backRight": "Back-Right",
    "insideKStyleGutterRun": "Inside K-style gutter run",
    "insideBoxGutterRun": "Inside Box gutter run",
    "insideSuperGutter": "Inside Super Gutter",
    "boxGutterWidthMeasurement": "Box Gutter width Measurement",
    "superGutterWidthMeasurement": "Super Gutter width Measurement",
    "fasciaBoardWidth": "Fascia Board Width",
    "fasciaBoardHeight": "Fascia Height",
    "soffitWidthHouseToEdge": "Soffit width (house to edge)",
    "soffitPanelMeasurement": "Soffit panel measurement",
    "poolScreens": "Pool screens",
    "miscellaneous1": "Miscellaneous 1",
    "miscellaneous2": "Miscellaneous 2",
    "miscellaneous3": "Miscellaneous 3",
    "miscellaneous4": "Miscellaneous 4"
  };

  // Define the desired order of labels
  const labelOrder = [
    "Right Side",
    "Left Side",
    "Back-Left",
    "Front of Home",
    "Front-Left",
    "Front-Right",
    "Back-Right",
    "Inside K-style gutter run",
    "Inside Box gutter run",
    "Inside Super Gutter",
    "Box Gutter width Measurement",
    "Super Gutter width Measurement",
    "Fascia Board Width",
    "Fascia Height",
    "Soffit width (house to edge)",
    "Soffit panel measurement",
    "Pool screens",
    "Miscellaneous 1",
    "Miscellaneous 2",
    "Miscellaneous 3",
    "Miscellaneous 4"
  ];

  // Transform the object to array
  return labelOrder.map(label => {
    // Find the key that corresponds to this label
    const key = Object.keys(keyToLabelMap).find(k => keyToLabelMap[k] === label);
    
    return {
      label: label,
      url: key ? (inputImages[key] || "") : ""
    };
  });
};